import { useState, useEffect } from "react";
import axios from "axios";

const CrearFamilia = () => {
    const [zonas, setZonas] = useState([]);
    const [diocesis, setDiocesis] = useState([]);
    const [zonaSeleccionada, setZonaSeleccionada] = useState("");
    const [diocesisSeleccionada, setDiocesisSeleccionada] = useState("");
    const [nombreFamilia, setNombreFamilia] = useState("");

    useEffect(() => {
        axios.get("http://192.168.1.81:5000/backend/api/zonas").then((response) => {
            setZonas(Array.isArray(response.data) ? response.data : []);
        }).catch(error => {
            console.error("Error al obtener zonas", error);
        });
    }, []);

    useEffect(() => {
        if (zonaSeleccionada) {
            axios.get(`http://192.168.1.81:5000/backend/api/diocesis?zona=${zonaSeleccionada}`)
                .then((response) => {
                    setDiocesis(Array.isArray(response.data) ? response.data : []);
                })
                .catch(error => {
                    console.error("Error al obtener diócesis", error);
                });
        }
    }, [zonaSeleccionada]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!diocesisSeleccionada || !nombreFamilia) {
            alert("Por favor, completa todos los campos.");
            return;
        }

        axios.post("http://192.168.1.81:5000/backend/api/familias", {
            nombre: nombreFamilia,
            diocesis_id: diocesisSeleccionada,
        })
            .then(() => {
                alert("Familia creada exitosamente");
                setNombreFamilia("");
                setZonaSeleccionada("");
                setDiocesisSeleccionada("");
            })
            .catch(error => {
                console.error("Error al crear la familia", error);
                alert("Hubo un error al crear la familia.");
            });
    };

    return (
        <div>
            <h2>Crear Familia</h2>
            <form onSubmit={handleSubmit}>
                <label>
                    Zona:
                    <select value={zonaSeleccionada} onChange={(e) => setZonaSeleccionada(e.target.value)}>
                        <option value="">Seleccione una zona</option>
                        {zonas.map((zona) => (
                            <option key={zona.id} value={zona.id}>{zona.nombre}</option>
                        ))}
                    </select>
                </label>
                <br />
                <label>
                    Diócesis:
                    <select value={diocesisSeleccionada} onChange={(e) => setDiocesisSeleccionada(e.target.value)} disabled={!zonaSeleccionada}>
                        <option value="">Seleccione una diócesis</option>
                        {diocesis.map((dio) => (
                            <option key={dio.id} value={dio.id}>{dio.nombre}</option>
                        ))}
                    </select>
                </label>
                <br />
                <label>
                    Nombre de la Familia:
                    <input type="text" value={nombreFamilia} onChange={(e) => setNombreFamilia(e.target.value.toUpperCase())} />
                </label>
                <br />
                <button type="submit">Crear Familia</button>
            </form>
        </div>
    );
};

export default CrearFamilia;